import { computed, Injectable, signal } from '@angular/core';
import type { ContextNavItem } from './context-nav.interfaces';
import type {
  SidebarListFooterAction,
  SidebarListVariant,
} from '../sidebar-list/sidebar-list.interfaces';

export interface ContextNavViewItem extends ContextNavItem {
  expanded: boolean;
  isStacked: boolean;
  triggerAvatarInitial: string;
  showCompactTriggerAvatar: boolean;
  chevronSize: number;
  popoverFooterActions: SidebarListFooterAction[];
  popoverVariant: SidebarListVariant;
  compactPopover: boolean;
}

function resolvePopoverVariant(item: ContextNavItem): SidebarListVariant {
  return item.variant ?? 'avatar';
}

@Injectable()
export class ContextNavViewStore {
  readonly items = signal<ContextNavItem[]>([]);
  readonly showTriggerAvatar = signal(true);
  readonly activeItem = signal<ContextNavItem | null>(null);

  readonly viewItems = computed<ContextNavViewItem[]>(() => {
    const activeId = this.activeItem()?.id;
    const showTriggerAvatar = this.showTriggerAvatar();

    return this.items().map(item => {
      const popoverVariant = resolvePopoverVariant(item);

      return {
        ...item,
        expanded: activeId === item.id,
        isStacked: !!item.triggerTitle,
        triggerAvatarInitial: item.triggerTitleInitial || item.initial,
        showCompactTriggerAvatar: !item.triggerTitle && showTriggerAvatar,
        chevronSize: item.triggerTitle ? 7 : 9,
        popoverFooterActions: item.footerActions ?? [],
        popoverVariant,
        compactPopover: popoverVariant === 'compact',
      };
    });
  });

  readonly activePopoverItem = computed<ContextNavViewItem | null>(
    () => this.viewItems().find(item => item.expanded) ?? null
  );

  setActiveItem(item: ContextNavItem | null): void {
    this.activeItem.set(item);
  }
}
